import { Controller } from "@hotwired/stimulus"

// A checklist that ticks itself forward on a timer while a background job
// runs — reassurance, not real progress.
export default class extends Controller {
  static targets = ["step", "badge"]
  static values = { interval: { type: Number, default: 2500 } }

  connect() {
    this.index = 0
    this.timer = setInterval(() => this.advance(), this.intervalValue)
  }

  disconnect() { clearInterval(this.timer) }

  advance() {
    if (this.index >= this.stepTargets.length - 1) { clearInterval(this.timer); return }
    this.complete(this.index)
    this.index += 1
    this.stepTargets[this.index].classList.remove("opacity-40")
  }

  complete(i) {
    const badge = this.badgeTargets[i]
    badge.textContent = "✓"
    badge.classList.add("bg-green-500", "border-green-500", "text-white")
  }
}
